"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const SalutationTypes_1 = __importDefault(require("../../common/js/enums/SalutationTypes"));
const translation_1 = require("../../common/js/helper/translation");
class SalutationStore {
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            salutations: mobx_1.computed,
        });
    }
    get salutations() {
        return Object.entries(SalutationTypes_1.default).map(([key, label]) => {
            return {
                value: key,
                label: (0, translation_1.t)(`registration.personal_information.salutation.options.${label}`),
            };
        });
    }
}
exports.default = new SalutationStore();
